"use strict";

exports.__esModule = true;
exports.default = void 0;
var platforms = [{
  value: 'wechat',
  title: '微信好友',
  scene: 'weixin-session',
  logo: 'ea37c0c6-e5ab-4e91-87dc-23e9654e4430.png',
  type: 'miniProgram',
  data: {
    'title': '分享的标题',
    'content': '分享的内容',
    'imgUrl': 'https://pic6.zhuanstatic.com/zhuanzh/dea3140a-8c01-42ac-bd9b-ecd978dc8b75.png',
    'jumpUrl': 'https://open.weixin.qq.com/',
    'miniProgram': {
      'appId': 'gh_c2980df66965',
      'path': 'pages/webview/webview?channel=100_mf_to_wechatfriends&isZzShare=1&url=url'
    }
  }
}, {
  value: 'moments',
  title: '朋友圈',
  scene: 'weixin-timeline',
  logo: '8988caa5-fbec-4bd1-bf77-13d00295b1ee.png',
  type: 'link',
  data: {
    'title': '分享的标题',
    'content': '分享的内容',
    'imgUrl': 'https://pic6.zhuanstatic.com/zhuanzh/dea3140a-8c01-42ac-bd9b-ecd978dc8b75.png',
    'jumpUrl': 'https://open.weixin.qq.com/'
  }
}, {
  value: 'qq',
  title: 'QQ',
  scene: 'qq-session',
  logo: '651472f0-2873-4352-931f-b2f3e77c63d9.png',
  type: 'link',
  data: {
    'title': '分享的标题',
    'content': '分享的内容',
    'imgUrl': 'https://pic6.zhuanstatic.com/zhuanzh/dea3140a-8c01-42ac-bd9b-ecd978dc8b75.png',
    'jumpUrl': 'https://open.weixin.qq.com/'
  }
}, {
  value: 'qzone',
  title: 'QQ空间',
  scene: 'qq-zone',
  logo: 'f971034b-ad02-4bfa-ab78-0f544b9298a4.png',
  type: 'link',
  data: {
    'title': '分享的标题',
    'content': '分享的内容',
    'imgUrl': 'https://pic6.zhuanstatic.com/zhuanzh/dea3140a-8c01-42ac-bd9b-ecd978dc8b75.png',
    'jumpUrl': 'https://open.weixin.qq.com/'
  }
}, {
  value: 'weibo',
  title: '微博',
  scene: 'weibo',
  logo: '9b49d2ed-82cc-4334-9d77-2917272b69a4.png',
  type: 'link',
  data: {
    'title': '分享的标题',
    'content': '分享的内容',
    'imgUrl': 'https://pic6.zhuanstatic.com/zhuanzh/dea3140a-8c01-42ac-bd9b-ecd978dc8b75.png',
    'jumpUrl': 'https://open.weixin.qq.com/'
  }
}];
var _default = platforms;
exports.default = _default;